// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getBoldedText from "@insite/client-framework/Common/Utilities/getPatternBolded";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { AutocompleteApiParameter, autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = { lineId: string; query: string, excludeParentProducts?: boolean };
type Props = {
    apiParameter: AutocompleteApiParameter;
    apiResult: ProductAutocompleteItemModel[] | null;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginSearchProducts: HandlerType = props => {
    props.dispatch({
        type: "xQuickOrderLine/ProductSelector/BeginSearchProducts",
        lineId: props.parameter.lineId,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        productEnabled: true,
        brandEnabled: false,
        categoryEnabled: false,
        contentEnabled: false,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.parameter.query.length > 0) {
        props.apiResult = (await autocompleteSearch(props.apiParameter)).products;
    }
};

export const SetDisplayTitles: HandlerType = props => {
    if (props.apiResult) {
        props.apiResult.forEach(product => {
            product.displayTitle = getBoldedText(product.title, props.apiParameter.query);
            product.displayErpNumber = getBoldedText(product.erpNumber, props.apiParameter.query);
        });
    }
};

export const DispatchCompleteSearchProducts: HandlerType = props => {
    props.dispatch({
        type: "xQuickOrderLine/ProductSelector/CompleteSearchProducts",
        result: props.apiResult,
        lineId: props.parameter.lineId,
    } as any);
};

export const chain = [
    DispatchBeginSearchProducts,
    PopulateApiParameter,
    RequestDataFromApi,
    SetDisplayTitles,
    DispatchCompleteSearchProducts,
];

const searchProducts = createHandlerChainRunnerOptionalParameter(
    chain,
    { lineId: "", query: "" },
    "SearchMiniQuickOrderProducts",
);
export default searchProducts;
